/**
 * Card-deck ("design") identities — the small shared enum so the web can offer a
 * deck picker (per-table AND per-user) and the game-server can validate a host's
 * choice on the wire (it rides `tableSettingsSchema`). The actual card ARTWORK is
 * web-only, so it lives in `apps/web/src/game/card-decks.ts` keyed by these ids —
 * this module carries no assets (it stays framework-free).
 *
 * A "deck" changes the card FACE graphic (the front — what a player reads in their
 * own hand); every deck shares one back. ⚠️ THE IDS ARE THE STORED ONES, THE ART
 * BEHIND THEM CHANGED (card-decks, 2026-10-20): a pick lives in localStorage and in
 * every private table's `settings.deck`, so the ids stay while the art and names
 * moved — `standard` «استاندارد» (the bundled classic SVG faces, the default),
 * `modern` «مدرن» (new legible vector art), `cartoon` «پارسه» (a four-colour deck —
 * the id is historical) and `royal` «سلطنتی». The three image decks are vector
 * files under `apps/web/src/assets/decks/`, content-hashed into `/assets/` by the
 * build; provenance and licences: `apps/web/src/assets/decks/ATTRIBUTION.md`.
 */
export const CARD_DECK_IDS = ["standard", "modern", "cartoon", "royal"] as const;
export type CardDeckId = (typeof CARD_DECK_IDS)[number];

/** The default deck (the current classic faces) — the value every settings default
 * falls back to, and what a pre-field frame / omitted choice resolves to. */
export const DEFAULT_CARD_DECK: CardDeckId = "standard";

/** Narrow untrusted input to a known deck id. */
export function isCardDeckId(value: unknown): value is CardDeckId {
  return typeof value === "string" && (CARD_DECK_IDS as readonly string[]).includes(value);
}
